import { QuestionTypeTag } from "./QuestionTypeTag";

type PreviewQuestionDescriptionProps = {
	description: string;
	questionType: string;
	required: boolean;
};
export const PreviewQuestionDescription = ({
	description,
	questionType,
	required,
}: PreviewQuestionDescriptionProps) => {
	return (
		<div className="flex items-center justify-between gap-2 pt-4">
			<h3 className="text-md font-medium text-secondary-700">
				{description}{" "}
				{required ? <span className="text-red-600">*</span> : null}
			</h3>
			{questionType ? <QuestionTypeTag questionType={questionType} /> : null}
		</div>
	);
};
